import React from 'react';
import {useNavigate} from "react-router-dom";
import FaceArt from '../../../assets/wrinkles/face_art.png';
import ScaleImage from '../../../assets/scale.png';
import {ArrowRightIcon} from "@radix-ui/react-icons";
import {useTranslation} from 'react-i18next';

const WrinklesBanner = () => {
    const navigate = useNavigate();
    const {t} = useTranslation('common');
    return (
        <div className="flex flex-row justify-between gb-banner items-center flex-wrap">
            <div>
                <h1 className="text-3xl font-bold">{t("glacies_ai_skin_analysis")}</h1>
                <p className="gb-secondary-text">{t("ai_scan_description")}</p>
            </div>
            <div className="flex justify-end gb-card gap-6 max-w-lg w-full">
                <div onClick={() => navigate('comparison')}
                     className="bg-white rounded-2xl p-6 drop-shadow-xl cursor-pointer h-full flex-1 shadow-md shadow-white hover:bg-gray-300 hover:shadow-gray-300">
                    <div className="flex flex-col justify-center items-center relative h-full">
                        <img src={ScaleImage} alt="face" width="100px"/>
                        <div className="flex gap-2 items-center">
                            <p className="text-fuchsia-800">{t('compare_results')}</p>
                            <ArrowRightIcon color="#9A3C8B"/>
                        </div>
                    </div>
                </div>
                <div onClick={() => navigate('ai-analysis')}
                     className="bg-white rounded-2xl h-full p-6 drop-shadow-xl cursor-pointer flex-1 shadow-md shadow-white hover:bg-gray-300 hover:shadow-gray-300">
                    <div className="flex flex-col justify-center items-center relative">
                        <img src={FaceArt} alt="face" width="100px"/>
                        <div className="flex gap-2 items-center">
                            <p className="text-fuchsia-800">{t('ai_analysis')}</p>
                            <ArrowRightIcon color="#9A3C8B"/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default WrinklesBanner;
